import {queryCard} from 'api/queryCard';
import Cookies from 'js-cookie';

const querycard = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        queryCard({commit},params) {
            return new Promise((resolve, reject) => {
                queryCard(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default querycard;



// WEBPACK FOOTER //
// ./src/store/modules/queryCard.js